import script from "./tradingViewWidget.vue?vue&type=script&allowJs=true&setup=true&lang=js"
export * from "./tradingViewWidget.vue?vue&type=script&allowJs=true&setup=true&lang=js"

const __exports__ = script;

export default __exports__